import { render, staticRenderFns } from "./add_items.vue?vue&type=template&id=17ad91b9&scoped=true&"
import script from "./add_items.vue?vue&type=script&lang=js&"
export * from "./add_items.vue?vue&type=script&lang=js&"
import style0 from "./add_items.vue?vue&type=style&index=0&id=17ad91b9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17ad91b9",
  null
  
)

export default component.exports